import { render, staticRenderFns } from "./Follow.vue?vue&type=template&id=15275fb4&"
import script from "../../models/analysis/follow.ts?vue&type=script&lang=ts&"
export * from "../../models/analysis/follow.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports